import Blockly from "blockly";

// 回数のブロックの文言は「%1」の前と後ろに分けて置く（英語は Repeat %1 times）
export const appendRepeatTimesFields = (
  input: Blockly.Input,
  options: ConstructorParameters<typeof Blockly.FieldDropdown>[0],
) => {
  const [before, after] = Blockly.utils.parsing
    .replaceMessageReferences("%{BKY_COURSE_REPEAT_TIMES}")
    .split("%1");
  if (before) {
    input.appendField(before, "before_label");
  }
  input.appendField(new Blockly.FieldDropdown(options), "TIMES").appendField(after, "label");
};

// 関数の呼び出しのブロックの名前の前の文言（英語は Call Function。日本語は名前だけ）
export const appendProcedureCallFields = (input: Blockly.Input) => {
  const title = Blockly.utils.parsing.replaceMessageReferences("%{BKY_COURSE_PROCEDURES_CALL}");
  if (title) {
    input.appendField(title, "call_label");
  }
  input.appendField("", "NAME");
};
